export function isEmpty(arg: Record<string, unknown> | string | undefined): boolean {
  if (arg === undefined) {
    return true;
  }
  if (typeof arg === 'object') {
    return Object.getOwnPropertyNames(arg).length === 0;
  }
  return !arg || /^\s*$/.test(arg) || !arg.trim();
}
